import React from 'react';
import PageLoader from "../../../components/pageLoader";
import useCarousel from "../../../hooks/public/useCarousel";
import Carousel from "../../../components/carousel/carousel";

const CarouselSlider = () => {
  const {data, isLoading} = useCarousel();
  const hasData = Array.isArray(data) && data.length > 0; // Check if `data` is a non-empty array

  return (
      <section className="carousel-slider-section">
        {isLoading && <PageLoader/>}
        {hasData && <Carousel data={data}/>}
      </section>
  );
};

export default CarouselSlider;
